import { render, staticRenderFns } from "./ClinicInviteAccept.vue?vue&type=template&id=542b056c&scoped=true"
import script from "./ClinicInviteAccept.vue?vue&type=script&lang=js"
export * from "./ClinicInviteAccept.vue?vue&type=script&lang=js"
import style0 from "./ClinicInviteAccept.vue?vue&type=style&index=0&id=542b056c&prod&scoped=true&lang=css"
import style1 from "./ClinicInviteAccept.vue?vue&type=style&index=1&id=542b056c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b056c",
  null
  
)

export default component.exports